import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Typography,
  Modal,
  Button,
} from "@mui/material";
import "./ActivateAccountAlert.css";

const ActivateAccountAlert = ({ open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box className="activate-account-alert">
        <Typography variant="h6" className="alert-title">
          Account Activation Required
        </Typography>
        <Typography variant="body2" className="alert-message">
          Trial users are not allowed to perform this action. Please activate your account first.
        </Typography>
        <Box className="alert-actions">
          <Button 
                variant="contained"
                color="error"
                className="quiz-action-button delete-button" 
                onClick={onClose}
            >
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

ActivateAccountAlert.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ActivateAccountAlert;
